import { TRACKING_TOUCH_POINTS } from '@/constant/trackingTouchPoints'

const IS_FEATURE_ENABLED = 'featureToggles/isFeatureEnabled'

const _state = {
  createdPresentationFromOnBoarding: false,
}

const _getters = {
  canUseKickstartScreenOneClickToSlideSelection: (_, __, rootState, rootGetters) => {
    // Google Slide integration runs a stripped-down editor without the
    // kickstart screen — force off so the flag has no effect regardless of
    // its remote state.
    if (rootState.integrationPlatform === 'GoogleSlide') return false
    return rootGetters[IS_FEATURE_ENABLED]('release-AHA-38483-kickstart-screen')
  },
  canUseNewKickstartScreen: (_, getters, __, rootGetters) => {
    return rootGetters[IS_FEATURE_ENABLED]('release-AHA-37344-blank-presentation') ||
      getters.canUseKickstartScreenOneClickToSlideSelection
  },
  // This one is to remove the default blank slide
  canUseOnBoardingKickstartScreen: (_, __, ___, rootGetters) => {
    return rootGetters[IS_FEATURE_ENABLED]('release-AHA-37361-on-boarding-blank-presentation')
  },
  // Controls the fix for the content panel not appearing after onboarding.
  canUseFixNoContentPanelAfterOnboarding: (_, __, ___, rootGetters) => {
    return rootGetters[IS_FEATURE_ENABLED]('release-AHA-38855-fix-no-content-panel-shows-after-onboarding')
  },
  isNewKickstartScreen: (_, getters, rootState) => {
    if (rootState.integrationPlatform === 'GoogleSlide') return false
    return !!(getters.canUseNewKickstartScreen && rootState.presentation?.slides?.every((s) => !s?.type))
  },
  kickStartScreenV2TrackingProps: (_, getters) => {
    if (!getters.isNewKickstartScreen) return null
    if (!getters.canUseKickstartScreenOneClickToSlideSelection) return null
    return {
      touchPoint: TRACKING_TOUCH_POINTS.KICKSTART_SCREEN_V2,
    }
  },
}

const mutations = {
  setCreatedPresentationFromOnBoarding(state, value) {
    state.createdPresentationFromOnBoarding = value
  },
}

const actions = {
  resetKickstartScreenStateAction: ({
    dispatch, rootState, state,
  }) => {
    if (rootState.isShowingSlideSearchPopup && !state.createdPresentationFromOnBoarding) {
      dispatch('setSlideSearchPopupVisibilityAction', false, { root: true })
      dispatch('patchPresentationAction', { isShowingSlideSearch: false }, { root: true })
    }
  },
  setCreatedPresentationFromOnBoardingAction: ({ commit }, value) => {
    commit('setCreatedPresentationFromOnBoarding', value)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
